import { render } from "./BlogSchemajson.vue?vue&type=template&id=4fa52380"
import script from "./BlogSchemajson.vue?vue&type=script&lang=js"
export * from "./BlogSchemajson.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__